import moment from 'moment';

import { getEarliestBeginDate, getLatestEndDate } from 'lib/components/Timeline/Timeline.helpers';
import { getId } from 'common/data.utils';
/* eslint-disable camelcase */
export const CHART_GOUPS = {
    NOTES: 'NOTES',
    EXCEPTIONS: 'EXCEPTIONS',
    RESTRICTIONS: 'RESTRICTIONS',
    TURBINE_STATUSES: 'TURBINE STATUS',
};

export const getStatusStartTime = (item) => {
    // TODO: return vs release time? return time can be negative
    const { release_time, ts } = item;

    let startTime;
    if (release_time) {
        startTime = moment.utc(release_time);
    } else {
        startTime = moment.utc(ts); // Axes time show without tz, because it would go out of chart
    }
    return startTime;
};

export const getStatusEndTime = (item, startTime) => {
    const { end_time } = item;
    let endTime;

    if (end_time) {
        endTime = moment.utc(end_time);
    } else {
        endTime = moment.utc(startTime).endOf('minute');
    }
    return endTime;
};

export const clampDate = (date, earliest, latest) => {
    if (date < earliest) {
        return earliest;
    }

    if (date > latest) {
        return latest;
    }

    return date;
};

export const createChartItem = (item, category, selectedDate) => {
    const { turbine_key, state } = item;

    const earliest = getEarliestBeginDate(selectedDate);
    const latest = getLatestEndDate(selectedDate);

    let turbineKey = turbine_key;

    if (!turbineKey) {
        turbineKey = getId(item);
    }

    const startTime = getStatusStartTime(item);
    const endTime = getStatusEndTime(item, startTime);

    return {
        key: category,
        turbineData: {
            ...item,
            id: turbineKey,
        },
        label: category,
        description: item.description || item.state || category,
        type: category === CHART_GOUPS.TURBINE_STATUSES ? state : 'DURATION',
        beginDate: clampDate(startTime, earliest, latest),
        endDate: clampDate(endTime, earliest, latest),
    };
};
